const PrivateNavBar = ({ children }) => {
  const auth = window.localStorage.getItem("token");
  return auth ? children : null;
};

export default PrivateNavBar;
